import { access } from 'fs';

const Dashboard = {
  text: 'Dashboard',
  link: '/dashboard',
};

const Projects = {
  text: 'Projects',
  link: '/projects',
  hideForNav: true,
  submenu: [
    {
      text: 'Settings',
      link: 'setting',
      icon: './assets/icons/Settings_Icon.svg',
      activeImg: './assets/icons/Settings-Icon-Purple.svg',
    },
    {
      text: 'Scenarios',
      link: 'scenario-list',
      icon: './assets/icons/Scenario_Icon.svg',
      panelId: 1,
      activeImg: './assets/icons/Scenario-Icon-Purple.svg',
      submenu: [
        {
          text: '',
          link: '#',
          submenu: [
            {
              text: 'Configuration',
              link: 'scenario-configuration',
            },
            {
              text: 'Pack materials',
              link: 'material-list',
            },
            {
              text: 'Product ingredients',
              link: 'ingredient-list',
            },
            {
              text: 'Product manufacturing',
              link: 'manufacture-list',
            },
            {
              text: 'Fill data',
              link: 'fill-data-list',
            },
            {
              text: 'Wholesale data',
              link: 'wholesale-data-list',
            },
            {
              text: 'Retail',
              link: 'retail-list',
            },
            {
              text: 'Consumer',
              link: 'consumer-list',
            },
            {
              text: 'End-of-life',
              link: 'end-of-life',
            },
          ],
        },
      ],
    },
    {
      text: 'Report',
      link: 'chart-at-glance',
      icon: './assets/icons/Report_Icon.svg',
      activeImg: './assets/icons/Report-Icon-Purple.svg',
      panelId: 2,
      submenu: [
        {
          text: 'Chart at a glance',
          link: 'chart-at-glance',
        },
        {
          text: 'Interpretation',
          link: 'interpretation',
        },
        {
          text: 'Report generation',
          link: 'report-generation',
        },
      ],
    },
  ],
};

const Products = {
  text: 'Products',
  link: '/products',
  hideForNav: true,
  submenu: [
    {
      text: 'Settings',
      link: 'setting',
      icon: './assets/icons/Settings_Icon.svg',
      activeImg: './assets/icons/Settings-Icon-Purple.svg',
    },
    {
      text: 'Products',
      link: 'product-list',
      icon: './assets/icons/Scenario_Icon.svg',
      panelId: 1,
      activeImg: './assets/icons/Scenario-Icon-Purple.svg',
      submenu: [
        {
          text: '',
          link: '#',
          submenu: [
            {
              text: 'Configuration',
              link: 'configurations',
            },
            {
              text: 'Ingredients',
              link: 'ingredient-list',
            },
            {
              text: 'Manufacturing',
              link: 'manufacture-list',
            },
            {
              text: 'Product use',
              link: 'product-use-list',
            },
            {
              text: 'End-of-life',
              link: 'end-of-life-list',
            },
          ],
        },
      ],
    },
    {
      text: 'Report',
      link: 'chart-at-glance',
      icon: './assets/icons/Report_Icon.svg',
      activeImg: './assets/icons/Report-Icon-Purple.svg',
      panelId: 2,
      submenu: [
        {
          text: 'Chart at a glance',
          link: 'chart-at-glance',
        },
        {
          text: 'Report generation',
          link: 'report-generation',
        },
      ],
    },
  ],
};

const Custom = {
  text: 'Custom',
  link: '#',
  submenu: [
    {
      text: 'Materials',
      link: '/custom/customMaterials',
    },
    {
      text: 'Conversion',
      link: '/custom/customConversion',
    },
    {
      text: 'Trucks',
      link: '/custom/customTrucks',
    },
    {
      text: 'Transport chains',
      link: 'custom/customTransport',
    },
    {
      text: 'Filling',
      link: '/custom/customFilling',
    },
    {
      text: 'Storage',
      link: '/custom/customStorage',
    },
    {
      text: 'Reuse',
      link: '/custom/customReuse',
    },
    {
      text: 'Waste scenarios',
      link: '/custom/wasteScenarios',
    },
  ],
};

const Settings = {
  text: 'Preferences',
  link: '#',
  submenu: [
    {
      text: 'Organization preferences',
      link: '/my-organization/organizationPreferences',
    },
    {
      text: 'Manage organization',
      link: '/my-organization/organizationPreferences',
      submenu: [
        {
          text: 'Manage users',
          link: '/my-organization/manageUsers',
        },
        {
          text: 'Manage teams',
          link: '/my-organization/manageTeams',
        },
        {
          text: 'Roles',
          link: '/my-organization/roles',
          accessString: 'Roles',
        },
        {
          text: 'Login settings',
          link: '/my-organization/SSOSettings',
        },
      ],
    },
    {
      text: 'Project workflow',
      link: '/my-organization/manageProjectWorkflow',
    },
    {
      text: 'Scenario workflow',
      link: '/my-organization/manageScenarioWorkflow',
    },
    {
      text: 'Payments',
      link: '#',
      submenu: [
        {
          text: 'Transactions',
          link: '/my-organization/Transactions',
        },
      ],
    },
    // Component is declared in Organization reporting module, not in CUSTOM
    {
      text: 'Equivalency units',
      link: 'my-organization/equivalency-unit',
    },
  ],
};

const Administrator = {
  text: 'Administrator',
  link: '#',
  submenu: [
    {
      text: 'User management',
      link: '#',
      accessString: 'User management',
      submenu: [
        {
          text: 'User',
          link: '/my-organization/AdminManageUsers',
          accessString: 'User',
        },
        {
          text: 'Teams',
          link: '/my-organization/AdminForManageTeams',
          accessString: 'Teams',
        },
        {
          text: 'Organizations',
          link: 'administrator/user-management/adminOrganization',
          accessString: 'Organization',
        },
        {
          text: 'Login logs',
          link: 'administrator/user-management/userLoginLogs',
          accessString: 'LogIn Logs',
        },
        {
          text: 'Merge org. logs',
          link: 'administrator/user-management/organizationLoginLogs',
          accessString: 'Merge org. logs',
        },
      ],
    },
    {
      text: 'Project management',
      link: '#',
      accessString: 'Project management',
      submenu: [
        {
          text: 'Projects',
          link: '/admin-projects',
          accessString: 'Projects',
        },
        {
          text: 'Custom materials',
          link: '/custom/adminCustomMaterials',
          accessString: 'Custom Material',
        },
        {
          text: 'Custom conversion',
          link: '/custom/adminCustomConversion',
          accessString: 'Custom Conversion',
        },
        {
          text: 'Custom trucks',
          link: '/custom/adminCustomTrucks',
          accessString: 'Custom Trucks',
        },
        {
          text: 'Custom filling',
          link: '/custom/adminCustomFilling',
          accessString: 'Custom Filling',
        },
        {
          text: 'Custom storage',
          link: '/custom/adminCustomStorage',
          accessString: 'Custom Storage',
        },
        {
          text: 'Custom reuse',
          link: '/custom/adminCustomReuse',
        },
        {
          text: 'Waste scenarios',
          link: '/custom/adminWasteScenarios',
          accessString: 'Waste Scenarios',
        },
        {
          text: 'Custom transport chain',
          link: '/custom/adminCustomTransport',
          accessString: 'Custom Transport Scenario',
        },
      ],
    },
    {
      text: 'Data management',
      link: '#',
      accessString: 'Data management',
      submenu: [
        {
          text: 'Materials impact data',
          link: 'administrator/data-management/materials-impact-data',
          accessString: 'Materials',
          submenu: [
            {
              text: 'Materials',
              link: 'administrator/data-management/materials-impact-data/admin-materials',
            },
            {
              text: 'Ingredients',
              link: 'administrator/data-management/materials-impact-data/admin-ingredients',
              accessString: 'Ingredients',
            },
            {
              text: 'Recycled material impact',
              link: 'administrator/data-management/materials-impact-data/admin-recycled',
            },
          ],
        },
        {
          text: 'Processing data',
          link: 'administrator/data-management/processing-data',
          submenu: [
            {
              text: 'Conversion',
              link: 'administrator/data-management/processing-data/processing-data-conversion',
            },
            {
              text: 'Area based conversions',
              link: 'administrator/data-management/processing-data/area-based-conversion',
            },
            {
              text: 'Product use impact',
              link: 'administrator/data-management/processing-data/product-use-impact',
            },
            {
              text: 'Product manufacture impact',
              link: `administrator/data-management/processing-data/product-manufacture-impact`,
            },
            {
              text: 'Transport',
              link: 'administrator/data-management/processing-data/Transport',
              accessString: 'Transport Mode Impacts',
            },
            {
              text: 'Refrigerated trucks',
              link: 'administrator/data-management/processing-data/refrigareted-truck',
              accessString: 'Refrigerated Trucks',
            },
            {
              text: 'Custom trucks',
              link: 'administrator/data-management/processing-data/processing-custom-truck',
            },
            {
              text: 'Energy and ancillary',
              link: 'administrator/data-management/processing-data/energy-and-ancillary',
            },
            {
              text: 'Custom conversion',
              link: 'administrator/data-management/processing-data/processing-custom-conversion',
            },
            {
              text: 'Storage',
              link: 'administrator/data-management/processing-data/processing-storage',
            },
            {
              text: 'Waste',
              link: 'administrator/data-management/processing-data/processing-waste',
            },
          ],
        },
        {
          text: 'EOL data',
          link: 'administrator/data-management/eol-data',
          submenu: [
            {
              text: 'EOL-RC',
              link: 'administrator/data-management/eol-data/admin-eol-rc',
            },
            {
              text: 'EOL-LF',
              link: 'administrator/data-management/eol-data/admin-eol-lf',
            },
            {
              text: 'EOL-CC',
              link: 'administrator/data-management/eol-data/admin-eol-cc',
            },
            {
              text: 'EOL-HC',
              link: 'administrator/data-management/eol-data/admin-eol-hc',
            },
            {
              text: 'EOL-ER',
              link: 'administrator/data-management/eol-data/admin-eol-er',
            },
            {
              text: 'EOL-IC',
              link: 'administrator/data-management/eol-data/admin-eol-ic',
            },
            {
              text: 'EOL-OD',
              link: 'administrator/data-management/eol-data/admin-eol-od',
            },
            {
              text: 'EOL-SW',
              link: 'administrator/data-management/eol-data/admin-eol-sw',
            },
            {
              text: 'EOL-SE',
              link: 'administrator/data-management/eol-data/admin-eol-se',
            },
            {
              text: 'EOL-LT',
              link: 'administrator/data-management/eol-data/admin-eol-lt',
            },
            {
              text: 'EOL-AD',
              link: 'administrator/data-management/eol-data/admin-eol-ad',
            },
            {
              text: 'EOL-OR',
              link: 'administrator/data-management/eol-data/admin-eol-or',
            },
            {
              text: 'EOL-CR',
              link: 'administrator/data-management/eol-data/admin-eol-cr',
            },
            {
              text: 'EOL-PG',
              link: 'administrator/data-management/eol-data/admin-eol-pg',
            },
            {
              text: 'EOL-OB',
              link: 'administrator/data-management/eol-data/admin-eol-ob',
            },
            {
              text: 'EOL-NO',
              link: 'administrator/data-management/eol-data/admin-eol-no',
            },
            {
              text: 'Conversion mapping',
              link: 'administrator/data-management/eol-data/admin-conversion-mapping',
            },
            {
              text: 'Recycled content',
              link: 'administrator/data-management/eol-data/admin-recycled-content',
            },
            {
              text: 'EOL retail rates',
              link: 'administrator/data-management/eol-data/admin-eol-rates',
            },
            {
              text: 'EOL consumer rates',
              link: 'administrator/data-management/eol-data/admin-eol-consumers',
            },
            {
              text: 'Product package ratio',
              link: 'administrator/data-management/eol-data/admin-product-package',
            },
          ],
        },
        {
          text: 'Other data',
          link: 'administrator/data-management/other-data',
          submenu: [
            {
              text: 'Material types',
              link: 'administrator/data-management/other-data/material-types',
            },
            {
              text: 'Recyclability',
              link: 'administrator/data-management/other-data/Recyclability',
            },
            {
              text: 'Combustibility',
              link: 'administrator/data-management/other-data/Combustibility',
            },
            {
              text: 'Compostability',
              link: 'administrator/data-management/other-data/Compostability',
            },
            {
              text: 'Circular economy parameters',
              link: 'administrator/data-management/other-data/CircularEconomyParameter',
            },
            {
              text: 'Country identifiers',
              link: 'administrator/data-management/other-data/CountryIndetifiers',
            },
            {
              text: 'Equivalency units',
              link: 'administrator/data-management/other-data/OrganizationEquivalancyUnits',
            },
            {
              text: 'Pallet types',
              link: 'administrator/data-management/other-data/pallet-type',
            },
            {
              text: 'Project status',
              link: 'administrator/data-management/other-data/Project-Status',
            },
            {
              text: 'Scenario status',
              link: 'administrator/data-management/other-data/scenario-status',
            },
          ],
        },
        {
          text: 'Converting processes',
          link: '/administrator/data-management/converting-processes',
        },
        {
          text: 'Misc simulation',
          link: '/administrator/data-management/misc-simulation',
        },
      ],
    },
    {
      text: 'Advanced',
      link: '#',
      accessString: 'Advanced',
      submenu: [
        {
          text: 'Roles',
          link: '/administrator/advanced/admin-roles',
          accessString: 'Roles',
        },
        {
          text: 'Log entries',
          link: '/administrator/advanced/log-entries',
          accessString: 'Log Entries',
        },
        {
          text: 'Import',
          link: '/administrator/advanced/import',
          accessString: 'Import',
        },
        {
          text: 'Country',
          link: '/administrator/advanced/country',
          accessString: 'Country',
        },
        {
          text: 'State',
          link: '/administrator/advanced/state',
          accessString: 'State',
        },
        {
          text: 'City',
          link: '/administrator/advanced/city',
          accessString: 'City',
        },
        {
          text: 'News',
          link: '/administrator/advanced/admin-news',
          accessString: 'News',
        },
        {
          text: 'Export logs',
          link: '/administrator/advanced/export-logs',
          accessString: 'Export Log',
        },
        {
          text: 'Bug tracker',
          link: '/administrator/advanced/report-list',
          accessString: 'Bug tracker',
        },
        {
          text: 'Searates API',
          link: '/administrator/sea-rates/api',
          accessString: 'Searates API',
        },
      ],
    },
    {
      text: 'Analytics',
      link: '/administrator/analytics',
      accessString: 'Analytics',
    },
    {
      text: 'Tool verification',
      link: '/administrator/tool-verification',
      accessString: 'Tool verification',
    },
    {
      text: 'Email Configuration',
      link: '#',
      accessString: 'Email Configuration',
      submenu: [
        {
          text: 'Automation',
          link: '/administrator/emailConfiguration/automation/list',
          accessString: 'Automation',
        },
        {
          text: 'Email templates',
          link: '/administrator/emailConfiguration/templates/list',
          accessString: 'Email templates',
        },
      ],
    },
    {
      text: 'Verification',
      link: '#',
      accessString: 'Verification',
      submenu: [
        {
          text: 'T&C verification',
          link: 'administrator/user-management/verification',
          accessString: 'Verification',
        },
        {
          text: 'Signup requests',
          link: 'administrator/user-management/signup-requests',
          accessString: 'Verification',
        },
      ],
    },
    {
      text: 'LCA API',
      link: '/administrator/analytics/lcaapi',
      accessString: 'lcaapi',
    },
    {
      text: 'Report builder',
      link: '#',
      accessString: 'Report builder',
      submenu: [
        {
          text: 'Template blocks',
          link: '/administrator/report-builder/blocks',
          accessString: 'Template blocks',
        },
        {
          text: 'Report templates',
          link: '/administrator/report-builder/templates',
          accessString: 'Report templates',
        },
        {
          text: 'Placeholders',
          link: '/administrator/report-builder/placeholders',
          accessString: 'Placeholders',
        },
        {
          text: 'Conditions',
          link: '/administrator/report-builder/conditions',
          accessString: 'Conditions',
        },
      ],
    },
  ],
};

const Organisationreporting = {
  text: 'Advanced',
  link: '#',
  submenu: [
    {
      text: 'Add internal data',
      link: '/organization-report/upload-sku',
    },
    {
      text: 'Org. packaging footprint report',
      link: '/organization-report/report',
      accessString: 'OrganizationReporting',
    },
    {
      text: 'Scope 3 packaging footprint (preview)',
      link: '/organization-report/scope3-packaging-footprint',
      accessString: 'OrganizationReporting',
    },
    {
      text: 'Export logs',
      link: '/my-organization/exportLogs',
      accessString: 'Export Log',
    },
    {
      text: 'Org. project import',
      link: '#',
      submenu: [
        {
          text: 'Piqet Template',
          link: '/organization-report/import-piqet-template',
        },
        {
          text: 'Custom Template',
          link: '/organization-report/import-custom-template',
        },
      ],
    },
    {
      text: 'Project report settings',
      link: '/my-organization/project-report-setting',
    },
    {
      text: 'Report builder',
      link: '#',
      submenu: [
        {
          text: 'Template blocks',
          link: '/report-builder/blocks',
        },
        {
          text: 'Report templates',
          link: '/report-builder/templates',
        },
      ],
    },
  ],
};

const help = {
  text: 'Help',
  link: '#',
  submenu: [
    {
      text: 'Guided tour',
      link: '#',
      submenu: [
        {
          text: 'Basic guided tour',
          link: '#',
        },
        {
          text: 'Advanced reporting tour',
          link: '#',
        },
        {
          text: 'Org. footprint tour',
          link: '#',
        },
      ],
    },
    {
      text: 'Manuals',
      link: '#',
      submenu: [
        {
          text: 'Tutorial exercise',
          link: '#',
        },
        {
          text: 'Indicator manual',
          link: '#',
        },
        {
          text: 'Data manual',
          link: '#',
        },
      ],
    },
    {
      text: 'Other resources',
      link: '#',
    },
    {
      text: 'Report a bug',
      link: '#',
    },
  ],
};

const Payment = {
  text: 'Payment',
  link: '#',
  icon: 'fa fa-cc-stripe',
  submenu: [
    {
      text: 'Transactions',
      link: 'payment/transactions',
      icon: 'fa fa-exchange',
    },
  ],
};

const HelpCenter = {
  text: 'Help Center',
  link: '#',
  icon: 'fa fa-comments menuicon',
};

const GuidedTour = {
  text: 'Guided Tour  ',
  link: '#',
  icon: 'fa fa-book menuicon',
};

export const menu = [
  Dashboard,
  Projects,
  Products,
  Custom,
  Settings,
  Administrator,
  Organisationreporting,
  help,
];
